/* unplugin-vue-components disabled */import { render } from "./F3DScaleAItem.vue?vue&type=template&id=a90d515e&scoped=true"
import script from "./F3DScaleAItem.vue?vue&type=script&lang=js"
export * from "./F3DScaleAItem.vue?vue&type=script&lang=js"

import "./F3DScaleAItem.vue?vue&type=style&index=0&id=a90d515e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a90d515e"]])

export default __exports__